import { FC, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { logSpinner } from "../../utils/performance";

interface ILoader {
  isLoading: boolean;
  /** When false, spinner is scoped to the page card instead of the viewport. */
  fullscreen?: boolean;
  /** Diagnostic label for console timing (e.g. "users-list"). */
  reason?: string;
}

const Loader: FC<ILoader> = ({
  isLoading,
  fullscreen = true,
  reason = "unspecified",
}) => {
  useEffect(() => {
    if (isLoading) {
      logSpinner(reason, true);
    }
  }, [isLoading, reason]);

  if (!isLoading) return null;

  const positionClass = fullscreen
    ? "position-fixed start-0 top-0 w-100 theme-loader-z-index"
    : "position-absolute start-0 top-0 w-100 h-100 rounded";

  return (
    <div
      className={`align-items-center bg-black bg-opacity-50 d-flex h-100 justify-content-center ${positionClass}`}
      aria-busy="true"
    >
      <Spinner animation="border" variant="light">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
};

export default Loader;
